<div #splide class="splide" [class.px]="paddingInline">
  <div class="splide__track">
    <ul class="splide__list" [class.justify-content-center]="centerSlides">
      <ng-content></ng-content>
    </ul>
  </div>
</div>
